/**
 * Plotting API - Generiranje plotova
 */

import { httpClient } from '../client/httpClient';
import { PlotData } from '../types/apiTypes';
import { logError, isAbortError } from '../utils/errorHandler';

export const plottingApi = {
  /**
   * Generiraj plot
   * Returns raw API response for backward compatibility
   */
  generatePlot: async (plotData: PlotData): Promise<unknown> => {
    try {
      const response = await httpClient.post<unknown>(
        '/api/training/generate-plot',
        plotData
      );

      if (!response.success) {
        throw new Error(response.error || 'Failed to generate plot');
      }

      return response;
    } catch (error) {
      logError('plottingApi.generatePlot', error);
      throw error;
    }
  },

  /**
   * Dohvati varijable za plot
   * Returns raw API response for backward compatibility
   */
  getPlotVariables: async (
    sessionId: string,
    signal?: AbortSignal
  ): Promise<unknown> => {
    try {
      const response = await httpClient.get<unknown>(
        `/api/training/plot-variables/${sessionId}`,
        { signal }
      );

      if (!response.success) {
        throw new Error(response.error || 'Failed to fetch plot variables');
      }

      return response;
    } catch (error) {
      // Don't log AbortError - it's expected when component unmounts
      if (!isAbortError(error)) {
        logError('plottingApi.getPlotVariables', error);
      }
      throw error;
    }
  },
};
